module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Text copyright © 2019 by Josef Centeno and Betty Hallock."), _c('br'), _vm._v("Photographs copyright © 2019 by Ren Fuller."), _c('br'), _vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-5685-9 (epub, mobi)")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data available.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 978-1-4521-5586-9 (hardcover)")]), _vm._v(" "), _c('p', [_vm._v("Prop styling by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("ALICIA BUSZCZAK")]), _vm._v("."), _c('br'), _vm._v("Food styling by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("JOSEF CENTENO")]), _vm._v("."), _c('br'), _vm._v("Design by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("VANESSA DINA")]), _vm._v("."), _c('br'), _vm._v("Typesetting by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("FRANK BRAYTON")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Chronicle books and gifts are available at special quantity discounts to corporations, professional associations, literacy programs, and other organizations. For details and discount information, please contact our premiums department at "), _c('a', {
    attrs: {
      "href": "mailto:corporatesales@chroniclebooks.com"
    }
  }, [_vm._v("corporatesales@chroniclebooks.com")]), _vm._v(" or at 1-800-759-0190.")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("WWW.CHRONICLEBOOKS.COM")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725bdf56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04copyright.vue
// module id = 69
// module chunks = 0